export enum MediaType {
  VIDEO = "VIDEO",
  IMAGE = "IMAGE"
}
export enum ReleaseType {
  Playlist = "Playlist",
  Media = "Media",
  "Curated List" = `Curated List`,
  Notification = "Notification",
  "Marketing Resource" = `Marketing Resource`,
  Branding = "Branding",
  "Device Settings" = `Device Settings`,
  CuratedSeriesList = "CuratedSeriesList",
  CuratedMediaList = "CuratedMediaList",
  CoherentScreen = "CoherentScreen"
}
export enum RestrictionType {
  Preschool = "Preschool",
  None = "None"
}
export enum StatType {
  View = "View",
  Duration = "Duration",
  Subscriber = "Subscriber"
}
export enum DeviceType {
  Desktop = "Desktop",
  Mobile = "Mobile",
  TV = "TV",
  "Head Set" = `Head Set`
}
export enum SocialMediaType {
  Facebook = "Facebook",
  Instagram = "Instagram",
  "Linked In" = `Linked In`,
  SnapChat = "SnapChat"
}
export enum MediaFormatQuality {
  Low = "Low",
  Medium = "Medium",
  High = "High",
  "Ultra HD" = `Ultra HD`
}
export enum LogLevel {
  Information = "Information",
  Verbose = "Verbose",
  Debug = "Debug",
  Warning = "Warning",
  Error = "Error"
}
export enum GroupType {
  IndividualProfile = "IndividualProfile",
  Profiles = "Profiles",
  DeviceType = "DeviceType",
  "Geographic Location" = `Geographic Location`
}
export enum PlayerPermission {
  ReadTargetGroup = "ReadTargetGroup",
  UpdateTargetGroup = "UpdateTargetGroup",
  DeleteTargetGroup = "DeleteTargetGroup",
  CreateTargetGroup = "CreateTargetGroup",
  CreateReleaseScheduleAction = "CreateReleaseScheduleAction",
  UpdateReleaseScheduleAction = "UpdateReleaseScheduleAction",
  ReadReleaseScheduleAction = "ReadReleaseScheduleAction",
  UpdateTitle = "UpdateTitle",
  CreateTitle = "CreateTitle",
  CreatePlayer = "CreatePlayer",
  UpdatePlayer = "UpdatePlayer",
  DeletePlayer = "DeletePlayer",
  GetPlayer = "GetPlayer",
  GetPlayers = "GetPlayers",
  CreatePlayerRole = "CreatePlayerRole",
  ReadPlayerRole = "ReadPlayerRole",
  UpdatePlayerRole = "UpdatePlayerRole",
  DeletePlayerRole = "DeletePlayerRole",
  AssignPlayerRole = "AssignPlayerRole",
  "Update Role" = `UpdateRole`,
  "Update Automatic Brand Publishing" = `UpdateAutomaticBrandPublishing`,
  "Get Account Payment Methods" = `GetAccountPaymentMethods`,
  "Get User Devices" = `Get User Devices`,
  FeedbackCRUD = "FeedbackCRUD",
  Logs = "Logs",
  InvitePlayer = "InvitePlayer"
}
export enum FlagType {
  Comment = "Comment",
  Media = "Media"
}
export enum MediationStepType {
  Initial = "Initial",
  "In Process" = `In Process`,
  Verify = "Verify",
  Complete = "Complete"
}
export enum ExpressedPreferenceType {
  Liked = "Liked",
  Disliked = "Disliked",
  Loved = "Loved"
}
export enum Gender {
  Male = "Male",
  Female = "Female",
  Other = "Other"
}
export enum Language {
  English = "English",
  Spanish = "Spanish",
  French = "French"
}
export enum IssueType {
  "Inappropriate Content" = `Inappropriate Content`,
  "Explicit Content" = `Explicit Content`
}
export enum Platform {
  Web = "Web",
  Mobile = "Mobile"
}
export enum Browser {
  Chrome = "Chrome",
  Firefox = "Firefox"
}
export enum Mobile {
  IOS = "IOS",
  Android = "Android"
}
export enum MarketResourceType {
  Banner = "Banner",
  "Copy Text" = `CopyText`
}
export enum ReleaseState {
  Released = "Released",
  Retired = "Retired",
  Pending = "Pending"
}
export enum MarketMetricType {
  Impressions = "Impressions"
}
export enum GameMetricType {
  "Active Time" = `Active Time`
}
export enum ProfileStatusType {
  Enabled = "Enabled",
  Disabled = "Disabled",
  Suspended = "Suspended"
}
export enum MediaStatus {
  Unreviewed = "Unreviewed",
  Reviewed = "Reviewed",
  RequestingApproval = "RequestingApproval",
  Rejected = "Rejected",
  Approved = "Approved"
}
export enum ReactionTypes {
  Like = "Like",
  Dislike = "Dislike"
}
export enum PaymentMethodTypes {
  "Credit Card" = `Credit Card`
}
export enum AccountStatus {
  Valid = "Valid",
  Suspended = "Suspended",
  Uninitialized = "Uninitialized"
}
export enum BrandingResponses {
  Inappropriate = "Inappropriate"
}
export enum PendingBrandingStatus {
  Pending = "Pending",
  Completed = "Completed"
}
export enum ProfilePermissions {
  "Branding Release Action CRUD" = `Branding Release Action CRUD`,
  "Set Pending Branding As Released" = `Set Pending Branding As Released`,
  "Branding Resources CRUD" = `BrandingResourcesCRUD`,
  "Comment CRUD" = `Comment CRUD`,
  "Device CRUD" = `DeviceCRUD`,
  "Send Feedback" = `Send Feedback`,
  "Set Flags" = `Set Flag`,
  "Set View Duration" = `SetViewDuration`,
  AcceptPlayerInvite = "AcceptPlayerInvite"
}
export enum PlayerAccountPermissions {
  "Get User Account" = `GetUserAccount`,
  "Update User Account" = `UpdateUserAccount`,
  "Device CRUD" = `Device CRUD`
}
export enum PlayerUserPermissions {
  "Read User" = `ReadUser`
}
export enum PlayerMediaPermissions {
  ApproveBranding = "ApproveBranding",
  "Set Media Comments Enabled" = `SetMediaCommentsEnabled`,
  "Curated List CRUD" = `Curated List CRUD`,
  "History CRUD" = `History CRUD`
}
export enum EnableStatus {
  Enabled = "Enabled",
  Disabled = "Disabled"
}
export enum BrandingResourceType {
  Watermark = "Watermark",
  "Banner Image" = `BannerImage`,
  "Profile Image" = `ProfileImage`
}
export enum PlayerReleasePermissions {
  "Curated List Release" = `Curated List Release`,
  ReleaseZoneCrud = "ReleaseZoneCrud"
}
export enum DeviceSettingTypes {
  "Device Polling Period Minutes" = `Device Polling Period Minutes`
}
export enum FeedbackCategory {
  General = "General"
}
export enum FlagState {
  Resolved = "Resolved",
  Unresolved = "Unresolved"
}
export enum PlayerMediationPermissions {
  "Flag CRUD" = `Flag CRUD`
}
export enum IssueState {
  Completed = "Completed",
  InProgress = "InProgress",
  NotStarted = "NotStarted"
}
export enum LogType {
  System = "System",
  Media = "Media",
  "Player Management" = `Player Management`
}
export enum PlayerMarketingPermissions {
  "Metrics CRUD" = `Metrics CRUD`,
  CuratedSeriesListCRUD = "CuratedSeriesListCRUD"
}
export enum PublishingState {
  Pending = "Pending",
  Published = "Published"
}
export enum PendingMediaCustomizationStates {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected"
}
export enum PlayerContentCreatorPermissions {
  ProcessedMediaCustomizationsCRUD = "ProcessedMediaCustomizationsCRUD"
}
export enum ReleaseActionType {
  ScheduledUnrelease = "ScheduledUnrelease",
  ScheduledRelease = "ScheduledRelease"
}
export enum NotificationStatus {
  Initial = "Initial",
  Sent = "Sent",
  Canceled = "Canceled"
}
export enum PlayerSystemPermissions {
  "Player CRUD" = `Player CRUD`,
  SystemCRUD = "SystemCRUD"
}
export enum PlaywatchSetting {
  "Media Quality Assurance" = `Media Quality Assurance`,
  "Profile Management" = `Profile Management`
}
export enum TagType {
  Media = "Media",
  "View Statistic" = `View Statistic`
}
export enum SystemSetings {
  ALLCRUD = "ALLCRUD"
}
export enum Views {
  Roles = "Roles",
  Players = "Players",
  Accounts = "Accounts",
  Addresses = "Addresses",
  Branding = "Branding",
  "Branding Resources" = `BrandingResources`,
  Category = "Category",
  "Device Settings" = `DeviceSettings`,
  "Expressed Preferences" = `ExpressedPreferences`,
  Flags = "Flags",
  Medias = "Medias",
  "Media Analytics" = `MediaAnalytics`,
  "Media Customizations" = `MediaCustomizations`,
  MediaDescriptions = "MediaDescriptions",
  "Media Informations" = `MediaInformations`,
  "Media Logs" = `MediaLogs`,
  "Media Lists" = `MediaLists`,
  "View Statistics" = `ViewStatistics`,
  Translations = "Translations",
  "Title Change Logs" = `TitleChangeLogs`,
  Titles = "Titles",
  Thumbnails = "Thumbnails",
  Teams = "Teams",
  "Target Groups" = `TargetGroups`,
  SystemSettings = "SystemSettings",
  "System Roles" = `SystemRoles`,
  Systems = "Systems",
  "Social Media Accounts" = `SocalMediaAccounts`,
  ReleaseZones = "ReleaseZones",
  "Release Schedule Actions" = `ReleaseScheduleActions`,
  "Public Playlists" = `PublicPlaylists`,
  "Profile Statuses" = `ProfileStatuses`,
  "Profile Roles" = `ProfileRoles`,
  "Profile Reactions" = `ProfileReactions`,
  "Profile Media Preferences" = `ProfileMediaPreferences`,
  "Profile Comments" = `ProfileComments`,
  Profiles = "Profiles",
  "Processed Social Media Accounts" = `ProcessedSocialMediaAccounts`,
  "Processed Media States" = `ProcessedMediaStates`,
  "Processed Media Customizatoins" = `processed/media/customizations`,
  "Processed Medias" = `processed/medias`,
  "Processed Brandings" = `processed/brandings`,
  Preferences = "preferences",
  "Playwatch Settings" = `playwatch/settings`,
  Playlists = "playlists",
  PlayerRole = "PlayerRole",
  "Pending Brandings" = `pending/brandings`,
  "Payment Methods" = `payment/methods`,
  CreateContentHouse = "CreateContentHouse",
  ContentCreators = "ContentCreators",
  ContentHouses = "ContentHouses",
  ContentHouse = "ContentHouse",
  ApprovalRequests = "ApprovalRequests",
  ReleaseManagement = "ReleaseManagement",
  Houses = "Houses",
  CuratedSeriesList = "CuratedSeriesList",
  CuratedMediaList = "CuratedMediaList",
  CoherentScreens = "CoherentScreens",
  SystemSchedule = "SystemSchedule",
  PreviewCoherentScreen = "PreviewCoherentScreen",
  Browse = "Browse",
  AddProfile = "AddProfile",
  EditProfile = "EditProfile",
  SelectProfile = "SelectProfile",
  EditProfileSelect = "EditProfileSelect",
  Watch = "Watch",
  ContentCreatorInvite = "ContentCreatorInvite",
  ProcessingdDashboard = "ProcessingdDashboard",
  MobileLogin = "MobileLogin",
  MetricConfiguration = "MetricConfiguration",
  MetricGraphs = "MetricGraphs",
  MediaResources = "MediaResources",
  Support = "Support",
  MobileConnect = "MobileConnect",
  playwatchkidsmobile = "playwatchkidsmobile",
  Search = "Search",
  PGCPS = "PGCPS",
  CustomerSettings = "CustomerSettings",
  CustomerAdministrator = "CustomerAdministrator"
}
export enum ViewType {
  List = "List",
  CreateUpdate = "CreateUpdate",
  View = "View"
}
export enum ContentHouseState {
  Pending = "Pending",
  Operational = "Operational"
}
export enum OwnerType {
  ContentCreator = "ContentCreator"
}
export enum ApprovalRequestType {
  Series = "Series",
  Media = "Media"
}
export enum ApprovalRequestStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Pending = "Pending",
  Canceled = "Canceled",
  Processing = "Processing",
  Initial = "Initial"
}
export enum ApprovalRequestLogType {
  Approval = "Approval",
  Rejection = "Rejection",
  Assigning = "Assigning",
  Unassigning = "Unassigning",
  Processing = "Processing"
}
export enum SystemSettingTypes {
  ReleaseZone = "ReleaseZone"
}
export enum Rating {
  G = "G",
  PG = "PG"
}
export enum ProcessJobState {
  Initial = "Initial",
  Ready = "Ready",
  InProgress = "InProgress",
  Complete = "Complete",
  Failed = "Failed"
}
export enum ResourcePropertyType {
  MediaRel = "MediaRel",
  MediaPreviewUrl = "MediaPreviewUrl",
  TransparentTitleUrl = "TransparentTitleUrl",
  Thumbnail = "Thumbnail",
  TitleMediaUrl = "TitleMediaUrl",
  TitleTransparentUrl = "TitleTransparentUrl",
  TitleMediaImageUrl = "TitleMediaImageUrl"
}
export enum BerryLayout {
  MainLayout = "MainLayout",
  MinimalLayout = "MinimalLayout",
  NetflixLayout = "NetflixLayout"
}
export enum MetricStep {
  TenMinutes = "600",
  Minute = "60",
  ThirtyMinutes = "1800",
  Hour = "3600",
  Day = "86400",
  Week = "604800",
  FourWeek = "2419200",
  TwentyEightWeek = "16934400"
}
export enum RawMetricKeys {
  WatchingMedia = "WatchingMedia",
  ViewPreview = "ViewPreview",
  ViewPreviewMedia = "ViewPreviewMedia",
  NewAccount = "NewAccount",
  NewDevice = "NewDevice",
  AddingProfile = "AddingProfile",
  EditingProfile = "EditingProfile",
  DeletingMedia = "DeletingMedia",
  CreateMedia = "CreateMedia",
  UpdateMedia = "UpdateMedia",
  RequestingApproval = "RequestingApproval",
  CancelRequest = "CancelRequest",
  MobileLoginView = "MobileLoginView",
  ConnectMobileLoginView = "ConnectMobileLoginView",
  WatchingMediaStream = "WatchingMediaStream",
  ActivelyWatching = "ActivelyWatching"
}
export enum OperatingSystems {
  Windows = "Windows",
  iOS = "iOS",
  Android = "Android",
  Mac = "Mac"
}
export enum Browsers {
  Chrome = "Chrome",
  Firefox = "Firefox",
  Opera = "Opera"
}
export enum MediaStatisticType {
  WatchingCount = "WatchingCount"
}
